import { Group, Material, Mesh } from 'three';

export const findTransparentMaterials = (group: Group): Material[] => {
  const mats: Material[] = [];
  group.traverse(obj => {
    if (!(obj instanceof Mesh)) return;
    if (Array.isArray(obj.material)) {
      mats.push(...obj.material);
    } else {
      mats.push(obj.material);
    }
  });
  return mats.filter(mat => mat.transparent);
};
